import type { FilterCriteria } from './vocabulary';

/** True when the field's declared data types include a boolean. */
export function checkIsBooleanField(types: string[]): boolean {
  return types.includes('boolean');
}

/** Resolve the declared data types for a field, case-insensitively. */
export function getValueTypesByField(
  field: string | undefined,
  filterOptions: Record<string, FilterCriteria>,
): Array<'string' | 'number' | 'boolean'> {
  if (!field) {
    return [];
  }

  const uppercasedField = field.toUpperCase();

  if (Object.prototype.hasOwnProperty.call(filterOptions, uppercasedField)) {
    return filterOptions[uppercasedField].data_types;
  }

  return [];
}
